export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-2">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">了解爆瓜网的故事与使命</p>

        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col items-center text-center">
            <div className="w-20 h-20 rounded-2xl bg-accent-100 flex items-center justify-center mb-6">
              <i className="ri-flashlight-line text-3xl text-accent-600"></i>
            </div>

            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-4">
              做最快、最全、最靠谱的娱乐资讯平台
            </h3>

            <div className="text-sm text-foreground-600 leading-relaxed space-y-4 max-w-2xl">
              <p>
                爆瓜网创立于2023年，由一群热爱娱乐产业的资深媒体人联合创办。我们致力于打造中国领先的娱乐资讯聚合平台，用最快的速度、最全的视角、最严谨的态度，为广大网友呈现娱乐圈的每一个精彩瞬间。
              </p>
              <p>
                我们拥有一支由资深娱乐记者、专业影视评论人和新媒体编辑组成的原创团队，同时与超过50家主流媒体和影视公司建立了内容合作关系。从明星动态到影视资讯，从综艺热点到行业趋势，从八卦爆料到深度专题，爆瓜网覆盖娱乐产业的每一个维度。
              </p>
              <p>
                在信息爆炸的时代，我们坚持"快速但不失准确，全面但不失深度"的编辑理念。每条信息经过多源交叉验证，重大内容标注可信度等级，让用户在享受吃瓜乐趣的同时，获得真实可靠的资讯体验。
              </p>
              <p className="text-primary-600 font-medium">
                吃瓜有态度，娱乐有深度 —— 这是爆瓜网不变的坚持。
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8 w-full max-w-lg">
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">580万</div>
                <div className="text-xs text-foreground-400 mt-1">月活跃用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">200+</div>
                <div className="text-xs text-foreground-400 mt-1">日均更新条数</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">50+</div>
                <div className="text-xs text-foreground-400 mt-1">合作媒体</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-heading font-bold text-primary-500">99.7%</div>
                <div className="text-xs text-foreground-400 mt-1">信息准确率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}